import React from 'react';
export function Footer() {
  return <footer className="bg-[#061b13] px-5 py-14 text-center" data-id="element-69" data-mp="32wd2cf6gdjt0">
      <div className="mx-auto max-w-3xl" data-id="element-70" data-mp="3gfivmltl4hfp">
        <p className="font-display text-3xl font-bold uppercase tracking-wide text-emerald-300" data-id="element-71" data-mp="3ggk90wy2pg0l">
          Educación Física Lista™
        </p>
        <p className="mt-3 font-bold text-white" data-id="element-72" data-mp="36p6aoshuym91">
          El sistema de planificación de Educación Física #1.
        </p>
        <p className="mt-2 text-sm italic text-slate-300" data-id="element-73" data-mp="3ug3gdnj28nbu">
          Porque planificar no debería quitarte la vida.
        </p>
        <div className="mx-auto mt-8 max-w-xl border-y border-emerald-300/20 py-6 text-xs font-bold uppercase tracking-widest text-slate-300" data-id="element-74" data-mp="37xxily2sakn">
          12 tomos · 5 bonos · 400+ sesiones · Primaria y Secundaria
        </div>
        <p className="mt-8 text-[10px] font-bold uppercase tracking-widest text-slate-500" data-id="element-75" data-mp="29z6tk9nn6feu">
          © Educación Física Lista™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}